import {
  AUTH_USER,
  AUTH_USER_REQUEST,
  UNAUTH_USER,
  AUTH_USER_ERROR
} from '../constants/auth'
import {
  reqTokenValid,
  reqTokenLogin,
  reqLogin
} from '../../utils/httpRequests/auth'
import {
  getUser
} from './user'
import history from '../../utils/history'
import decoded from 'jwt-decode'
import {parseJSON} from '../../utils/misc'

const ERROR_SYSTEM_MATCH = /ENH$/;
const ERROR_SYSTEM = 'Error de sistema: ENH';
const ERROR_WRONG_USER = 'No tiene los permisos necesarios para ingresar';

const handleLoginError = (err, dispatch) => {
  console.log(err);
  const {response} = err;

  let payload = ERROR_WRONG_USER;

  if (response) {
    const {status, data} = response;

    if (status === 400 && !data.success && ERROR_SYSTEM_MATCH.test(data.message)) {
      payload = ERROR_SYSTEM;
    }
  }

  dispatch({
    type: AUTH_USER_ERROR,
    payload
  });
  return false;
}

export function oauthLogin(credential, recaptchaToken) {
  return (dispatch) => {
    dispatch({
      type: AUTH_USER_REQUEST
    });

    return reqLogin(credential, recaptchaToken)
      .then(parseJSON)
      .then(response => {
        dispatch(loginUserSuccess(response.token))
        history.push('/backoffice')
        return true
      })
      .catch(err => handleLoginError(err, dispatch));
  };
}

export function isTokenValid(token) {
  return reqTokenValid(token)
    .then(parseJSON)
    .then((response) => {
      return response
    })
}

export function tokenLogin(newToken) {
  return reqTokenLogin(newToken)
    .then(parseJSON)
    .then((response) => {
      return response
    })
}

export function loginUserAndCleanUrl(token) {
  return (dispatch) => {
    dispatch(loginUserSuccess(token))
    let location = history.location.pathname
    history.replace(location)
  }
}

export function loginUserSuccess(token) {
  return (dispatch) => {
    const decodedToken = decoded(token)
    localStorage.setItem('token', token)
    dispatch({
      type: AUTH_USER,
      payload: {
        token: token,
        permissions: decodedToken.permissions,
        type: decodedToken.type
      }
    })
    dispatch(getUser(token))
  }
}

export function logout() {
  localStorage.removeItem('token')
  return {
    type: UNAUTH_USER
  }
}

export function logoutAndRedirect() {
  return (dispatch, getState) => {
    const {type} = getState().auth
    dispatch(logout())
    if (type === 'CCLAUser') {
      history.push('/login')
    } else {
      window.location = process.env.SV_HOME_URL || 'https://www.cajalosandes.cl/home_personas'
    }
  }
}
